if (typeof window !== "undefined") {
  window.__ARTI_DASHBOARD_CONFIG__ ??= {};
}
